<!-- <div class="page-title-container d-flex ">
<div class="page-title flex-grow-1 ng-star-inserted">
  <div class="mb-0 ng-star-inserted">
    <div class="_wf-db-bedmangtxt">
      <div class="text-capitalize"> {{resource.title}} </div>
    </div>
  </div>
</div>
</div> -->
<!-- <div class="main-content-container">
<div class="main-container-body"> -->
  <!-- <div class="_wf-db-bedmangtxt">
  <div class="text-capitalize"> {{resource.title}} </div>
</div> -->
<div class="app-ui-engine-container _wf-db-mainshadesiv _wf-bd-mainshagemobile main-box-shadow">
  @if (resource) {
    @if (filterAr != undefined && filterAr.length) {
      <div class="row mt-2">
        <div class="drug-filter-container d-flex w-100 ml-2 mr-4 justify-content-between">
          <div class="bookmarks-container ml-2 mr-2">
            <div class="col-12 p-0">
              @for (filter of filterAr; track filter) {
                <div class="fav-bookmark">
                  @if (checkFilterCondition(filter)) {
                    <div class="bookmark-chip"
                      [ngClass]="filter.name == filterConfig.FilterName ? 'active': ''" style="cursor: pointer;">
                      <span (click)="applyFilter(filter)"> {{ filter.name }}</span>
                      @if (filter.name == filterConfig.FilterName) {
                        <i class="fa fa-check ml-1"></i>
                      }
                    </div>
                  }
                </div>
              }
              @if (preferenceData && preferenceData['filter__'] != undefined && preferenceData['filter__'].length > 0) {
                <a href="javascript:void(0)" title="Manage Filters" (click)="manageFilter()" class="_fav-3-dots">
                  <div class="_fav-3-dots-container">
                    <img src="assets/images/icon-context.svg">
                  </div>
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div class="_wf-db-bordershade">
      <div class="_wf-db-topicons-2">
        @if (resource && resource.filter != undefined) {
          <div class="grid-search-wrapper">
            <!-- <div class="_wf-db-filter-txt secondary-btn" (click)="displayFilter()">
            <div class="_wf-db-txtfiler">Filter</div>
            <div class="_wf-db-fiterl-icon">
              <i class="fa fa-filter" aria-hidden="true"></i>
            </div>
          </div> -->
          <div class="_filter-button-wrapper">
            <ng-container>
              <div class="_filter-button" (click)="displayFilter()">
                <i class="fa fa-filter" aria-hidden="true"></i>
              </div>
            </ng-container>
          </div>
          <div style="margin-left: 1px;">
            <app-complex-search [config]="config" (onFilterChange)="onFilterClick($event);">
            </app-complex-search>
          </div>
          <!-- <div class="_wf-db-srch-main">
          <span class="_wf-dg-icon" id="basic-addon2" (click)="onFilterClick(filterKey)"><i
          class="fa fa-search" aria-hidden="true"></i></span>
          <input type="text" class="search form-control" pattern="[^A-Za-z0-9]"
            [(ngModel)]="filterKey" placeholder="Search" (keydown)="onFilter($event)">
        </div> -->
      </div>
    }
    <!-- <div class="">
    <div *ngIf="resource.filter != undefined">
      <button type="button" class="secondary-btn" (click)="displayFilter()">
        <span class="btn-text mr-2">
          Filter
        </span>
        <span class="btn-icon">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  </div> -->
  <!-- <div class="ml-2">
  <div class="grid-search-container mr-2">
    <div class="input-group grid-smart-search-container">
      <span class="grid-smart-search" id="basic-addon2" (click)="onFilterClick(filterKey)"><i
      class="fa fa-search" aria-hidden="true"></i></span>
      <input type="text" class="search form-control" pattern="[^A-Za-z0-9]"
        [(ngModel)]="filterKey" placeholder="Search" (keydown)="onFilter($event)">
    </div>
  </div>
</div> -->
<!-- <div class="text-capitalize ml-5"><span *ngFor="let c of resource.css | keyvalue"><span class="dot"
[style.background-color]="c.value"> </span> {{c.key}} </span>
</div> -->
<!-- <div class="_wf-db-rgt-icons">
<div class="_wf-db-webtotalbeds">
  <div class="_wf-db-webtotaltxt-bed">
    <div class="text-block-85" *ngIf="this.totalBeds != undefined">TOTAL {{totalBeds}} BEDS
    </div>
  </div>
  <div class="_wf-db-webrgtpointsdiv">
    <div class="_wf-db-webrgttotaldiv">
      <div class="_wf-db-bedspoints-dots text-block-84 text-capitalize"
        *ngFor="let c of resource.css | keyvalue">
        <span class="dot" [style.background-color]="c.value"></span>
        {{c.key}}
        <span *ngIf="c.key=='housekeeping'"> ({{housekeeping_bed}})</span>
        <span *ngIf="c.key=='occupied'"> ({{occupied_bed}})</span>
        <span *ngIf="c.key=='occupied(In-housekeeping)'">
        ({{occupiedwithhousekeeping_bed}})</span>
        <span *ngIf="c.key=='vacant'"> ({{vacant_bed}})</span>
        <span *ngIf="c.key=='reserved'"> ({{reserved_bed}})</span>
        <span *ngIf="c.key=='blocked'"> ({{blocked_bed}})</span>
      </div>
    </div>
  </div>
</div>
</div> -->
</div>
<div class="bed-visibility">
  <div class="bed-visibility-label">
    Bed Visibility
  </div>
  @if (totalBeds) {
    <div class="bed-total-count">
      Overall occupancy {{total_occupancy}}%({{occupied_bed}} / {{totalBeds}})
    </div>
  }
  <div class="bed-stages">
    @for (v of resource.css | keyvalue:originalOrder; track v) {
      <div class="_bed-stage bed-available">
        <div class="bed-stage-icon">
          <img src="/assets/images/bedmanagement/{{v.value}}">
        </div>
        <div class="bed-stage-label">
          <label class="text-capitalize">{{v.key}}</label>
        </div>
      </div>
    }
  </div>
</div>
</div>
}
<div class="_wf-db-greybg bed-mgmt-filter">
  <!-- ******added for mobile responsive******-->
  <!-- <div class="_wf-db-seacrhmain">
  <div class="_wf-db-secricon" *ngIf="resource && resource.filter != undefined">
    <div class="_wf-db-fiterl-icon" (click)="displayFilter()">
      <i class="fa fa-filter" aria-hidden="true"></i>
    </div>
    <app-complex-search [config]="config" (onFilterChange)="onFilterClick($event);">
    </app-complex-search>
  </div>
</div> -->
<!-- ******added for mobile responsive******-->
<!-- <div class="_wf-db-totalbeds">
<div class="_wf-db-totaltxt-bed">
  <div class="text-block-85" *ngIf="this.totalBeds != undefined">TOTAL {{totalBeds}} BEDS</div>
</div>
<div class="_wf-db-rgtpointsdiv">
  <div class="_wf-db-rgttotaldiv">
    <div class="_wf-db-bedspoints-dots">
      <span class="text-capitalize text-block-84" *ngFor="let c of resource.css | keyvalue"><span
      class="dot" [style.background-color]="c.value"> </span> {{c.key}}
      <span *ngIf="c.key=='housekeeping'"> ({{housekeeping_bed}})</span>
      <span *ngIf="c.key=='occupied'"> ({{occupied_bed}})</span>
      <span *ngIf="c.key=='occupied(In-housekeeping)'">
      ({{occupiedwithhousekeeping_bed}})</span>
      <span *ngIf="c.key=='vacant'"> ({{vacant_bed}})</span>
      <span *ngIf="c.key=='reserved'"> ({{reserved_bed}})</span>
      <span *ngIf="c.key=='blocked'"> ({{blocked_bed}})</span>
    </span>
  </div>
</div>
</div>
</div> -->
<div class="row filter-grid" [hidden]="!(resource && resource.filter && resource.filter.default_open)">
  <ng-container>
    <!-- *ngIf="resource.filter != undefined && resource.filter.default_open" -->
    <div class="col-12 pl-4 pr-4">
      <div class="grid_filter">
        <div class="filter-body">
          <span class="close-filter-btn" (click)="displayFilter()">
            <i class="fa fa-times-circle" aria-hidden="true"></i></span>
            <div class="filter-form" [hidden]="!resource.filter">
              <kx-filter #kxFilter [config]="filterConfig" [persistValue]="config" [fields]="resource.filter" (getFilter)="doSearch($event)" (getData)="getDataFn($event)"
                (resetFilter)=resetFilter($event)>
              </kx-filter>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  @for (ward of hasBedDetails; track ward) {
    <div>
      <div class="card-heading-label">
        <b>{{ward.ward_name}}</b>
      </div>
      @if (hasDetailView) {
        <div class="bed-mgmt-card-main" [ngStyle]="{'background':(ward.background|ColortoHex)}">
          <div class="row">
            <div class="col-12">
              <div class="_wf-bd-bedtabsmain">
                @for (bed of ward.bedDetails; track bed; let i = $index) {
                  <div class="_wf-db-bedone">
                    <div class="single-bed" [ngClass]="bed.bed_zone?bed.bed_zone:'neutral_zone'"
                      (click)="hasPatientDetails($event, bed)" [popover]="popTemplateForBed"
                      [outsideClick]="true" containerClass="bed-popover" container="body"
                      placement="auto">
                      @if (bed.patient_details && bed.patient_details.isExtraBed) {
                        <div class="_wf-db-colouriconsbg">
                          <div class="text-block-120"><img
                            src="assets/images/bedmanagement/extrabed.svg"
                          class="bedSize my-2 name{{bed.id}}" style="margin:auto" /></div>
                        </div>
                      } @else if (bed.patient_details && bed.patient_details.mark_for_discharge) {
                        <div class="_wf-db-colouriconsbg">
                          <div class="text-block-120"><img
                            src="assets/images/bedmanagement/initiatedischarge.svg"
                          class="bedSize my-2 name{{bed.id}}" style="margin:auto" /></div>
                        </div>
                      } @else if (bed.patient_details && bed.patient_details.mark_for_discharge && bed.patient_details.isExtraBed) {
                        <div class="_wf-db-colouriconsbg">
                          <div class="text-block-120"><img
                            src="assets/images/bedmanagement/_occupied-both.svg"
                          class="bedSize my-2 name{{bed.id}}" style="margin:auto" /></div>
                        </div>
                      } @else {
                        @if (bed.stage_action != 'occupied' && bed.stage_action != 'occupiedwithhousekeeping') {
                          <div class="_wf-db-colouriconsbg">
                            <div class="text-block-120"><img
                              src="assets/images/bedmanagement/{{bed.stage_action}}.svg"
                            class="bedSize my-2 name{{bed.id}}" style="margin:auto" /></div>
                          </div>
                        }
                        @if ((bed.stage_action == 'occupied' || bed.stage_action == 'occupiedwithhousekeeping') && bed.patient_details && bed.patient_details.patient_gender_id) {
                          <div class="_wf-db-colouriconsbg">
                            <div class="text-block-120">
                              @if (bed.stage_action == 'occupied' && bed.patient_details.patient_gender_id != 'male' && bed.patient_details.patient_gender_id != 'female') {
                                <img src="assets/images/bedmanagement/occupied_other.svg"
                                class="bedSize my-2 name{{bed.id}}{{bed.stage_action}}" style="margin:auto" />
                              } @else {
                                <img src="assets/images/bedmanagement/{{bed.stage_action}}{{bed.patient_details.patient_gender_id}}.svg"
                                class="bedSize my-2 name{{bed.id}}{{bed.stage_action}}" style="margin:auto" />
                              }
                            </div>
                          </div>
                        }
                        @if ((bed.stage_action == 'occupied' || bed.stage_action == 'occupiedwithhousekeeping') && !(bed.patient_details && bed.patient_details.patient_gender_id)) {
                          <div class="_wf-db-colouriconsbg">
                            <div class="text-block-120"><img
                              src="assets/images/bedmanagement/{{bed.stage_action}}.svg"
                            class="bedSize my-2 name{{bed.id}}" style="margin:auto" /></div>
                          </div>
                        }
                      }
                    </div>
                    <div class="text-block-121">{{bed.name}}</div>
                    <div class="patientDetailsCss" id="{{bed.id}}" style="display: none;">
                      <ng-template #popTemplateForBed>
                        @if (patientData) {
                          <div>
                      @if (bed.stage == 'blocked') {
                      <p class="py-2 font-size-text">
                        {{resource.custom_messages[bed.stage_action]}}</p>
                      }
                      @for (f of fields; track f) {
                        @if (
                          (bed.stage == 'blocked' && bed.stage_action=='blocked' && f.conditions && checkCondition(f.conditions, bed))
                          ||
                          (bed.stage != 'blocked' && !f.conditions)){
                              <span>
                                <span class="font-size-text"><b>{{f.heading | translate |
                                async}} :</b>
                                {{getValue(patientData, f) | translate | async}}
                              </span><br>
                            </span>
                         }
                      }
                      @if (isOpen) {
                        <div class="pt-2 d-flex justify-content-center flex-wrap">
                          @for (r of resource.capability; track r) {
                            <div class="">
                          @if ((bed.stage== 'blocked' || !r.buttonType) && checkPermission(r)) {
                          <span>
                            @if (bed.stage == 'blocked'
                            ? checkCondition(r.conditions, bed)
                            : checkCondition(r.conditions, patientData)) {
                                        <button type="button" class="secondary-btn mb-2"
                                          (click)="redirectUrl(r,patientData);"
                                          >
                                          @if (r.icon) {
                                            <i class="{{r.icon}}" aria-hidden="true"></i>
                                          } {{r.label| translate | async}}</button>
                                        }
                                      </span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                        @if (!patientData) {
                          <div>
                            <p class="py-2 font-size-text">
                            {{resource.custom_messages[bed.stage_action]}}</p>
                            @if (isOpen) {
                              <div class="pt-2 d-flex justify-content-center">
                                @for (r of resource.capability; track r) {
                                  <div class="">
                                    @if (r.buttonType && checkPermission(r)) {
                                      <span>
                                        @if (checkCondition(r.conditions,bed)) {
                                          <button type="button" class="secondary-btn"
                                            (click)="redirectUrl(r,bed)"
                                            >{{r.label |
                                          translate | async}}</button>
                                        }
                                      </span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </ng-template>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      @if (!hasDetailView) {
        <div class="">
          <div class="row">
            <div class="col-12">
              @for (bed of ward.bedDetails; track bed; let i = $index) {
                <div class="float-left col-md-2 col-sm-6">
                  <i class="fa fa-bed bedSize {{bed.stage}}" aria-hidden="true"></i><br>
                  <strong>{{bed.name}}</strong>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
<!-- </div>
</div> -->
</div>

<div dhs-modal></div>